export const ClockIcon = ({ className = '', style = {}, ...props }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ verticalAlign: 'middle', ...style }}
      {...props}
    >
      <defs>
        <linearGradient id="sparkle-gradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#2368F6" />
          <stop offset="100%" stopColor="#A717CB" />
        </linearGradient>
      </defs>
      <path
        fill="url(#sparkle-gradient)"
        d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
      />
    </svg>
  );
};
